




































import { Vue, Component, Prop } from "vue-property-decorator";
import ModalBase from '@/components/ModalBase.vue';
import InputRadio from '@/components/InputRadio.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import Button from "@/components/Button.vue";

@Component({
  components: {
    Button,
    ModalBase,
    InputRadio
  }
})

export default class TimeslotSelector extends Vue {
  @Prop({ default: () => [] }) readonly slots!: Array<TimeSlot>
  @Prop() readonly selectedDate!: string
  
  currentSlot: null | TimeSlot= null

  formattedSlotString (slot: TimeSlot) {
    if (slot.pickupNow) {
      return this.$t('label.pickup-now')
    }
    return this.slotString(slot)
  }

  slotString (slot: TimeSlot) {
    if (!slot) return null
    return `${slot.startTime}-${slot.endTime}`
  }

  handleSelect (slot: TimeSlot) {
    this.currentSlot = slot
  }

  handleCancel () {
    this.$emit('cancel')
  }

  handleConfirm () {
    this.$emit('select', this.currentSlot)
  }
}
